let header = jQuery('.header')

jQuery('.body__before').on('click', function(e) {

    if( jQuery('body').hasClass('is-drawer') ){
        jQuery('.header .hamburger').trigger('click')
    }
    if(jQuery('body').hasClass('is-search')){
        jQuery('body').toggleClass('is-search')
    }

})

jQuery(document).on('keydown', function (e) {

    if( jQuery('body').hasClass('is-search') ){
        if (e.keyCode === 27) {
            jQuery('body').removeClass('is-search');
            setTimeout(function () {
                jQuery('.header__search').focus();
            }, 100); // Adjust the timeout delay as needed
        }
    }

    if( jQuery('body').hasClass('is-drawer') ){
        if (e.keyCode === 27) {
            jQuery('body').removeClass('is-drawer');
            setTimeout(function () {
                jQuery('.hamburger').toggleClass('is-active')
                jQuery('.hamburger').attr('tabindex', '0').focus()
            }, 100); // Adjust the timeout delay as needed
        }
    }
});

jQuery(document).ready(function() {

    const headerHeight = jQuery('.header').outerHeight();
    jQuery('.header__drawer').css('padding-top', headerHeight + 'px');

    jQuery('.search__holder').css('padding-top', headerHeight + 'px');
    const $menuHeads = jQuery('.header__drawer__menu__head');

    $menuHeads.on('click', function() {
        const $section = jQuery(this).closest('.header__drawer__menu__latest, .header__drawer__menu__explore');
        // Toggle current section
        $section.toggleClass('is-open');
    });
});

jQuery('.hamburger').on('click', function (e) {

    e.preventDefault()

    if (jQuery(this).hasClass('is-active')) {
        // jQuery('.drawer').attr('tabindex', '-1')
    } else {
        // jQuery('.drawer').attr('tabindex', '1').focus()
    }

    jQuery('body').toggleClass('is-drawer')
    jQuery('body').removeClass('is-search')
    jQuery('.hamburger').toggleClass('is-active')

    jQuery('.header__right').scrollTop(0)

})

jQuery('.header__search').on('click', function (e) {
    jQuery('body').toggleClass('is-search')
    jQuery('body').removeClass('is-drawer')
    jQuery('.hamburger').removeClass('is-active')
    setTimeout(function () {
        jQuery('.search__form #drawer_search_input')[0].focus();
    }, 420);
})

jQuery('.close__search').on('click', function (e) {
    jQuery('body').toggleClass('is-search')
    setTimeout(function () {
        jQuery('.header__search').focus();
    }, 100);
})

document.addEventListener('keyup', function(e) {

    if(jQuery('.is-drawer').length > 0){
        // var logobutton = jQuery('.header__logo a');
        var drawerbutton = jQuery('.hamburger-toggle button');
        var lastAnchorElement = jQuery('.header #menu-footer-secondary-menu li:last-child a');
        var firstAnchorElement = jQuery('.header #menu-drawer li:first-child a');

        if (e.keyCode == 13 && jQuery('body').hasClass('is-drawer') ) {

            // e.preventDefault();

            lastAnchorElement.on('keydown', function(e) {

                // e.preventDefault();

                if (e.key === 'Tab') {
                    if (  e.shiftKey) {

                        firstAnchorElement.attr('tabindex', '0').focus();
                        e.preventDefault();

                    } else {

                        drawerbutton.attr('tabindex', '0').focus();
                        e.preventDefault();

                    }
                }
            });

            drawerbutton.on('keydown', function(e) {

                // e.preventDefault();

                if (e.key === 'Tab') {
                    if (e.shiftKey) {

                        lastAnchorElement.attr('tabindex', '0').focus();
                        e.preventDefault();

                    } else {

                        firstAnchorElement.attr('tabindex', '0').focus();
                        e.preventDefault();
                    }
                }
            });

        }
        // if( jQuery('body').hasClass('is-drawer') ){
        //     if(e.keyCode == 27){
        //         console.log('esc')
        //         e.preventDefault();
        //         lastAnchorElement.off()
                

        //         // jQuery('body').toggleClass('is-drawer')
        //         // jQuery('.hamburger').toggleClass('is-active')
        //     }
        // }
        // jQuery('.header__drawer').addAttr('tabindex', '0')
        jQuery('.header__drawer').find('*').removeAttr('tabindex');
    } else {
        jQuery('.header__drawer').find('*').attr('tabindex', '-1');
    }
});


jQuery('.drawer__nav .toggle').on('click', function (e) {

    e.preventDefault()

    let thisEl = jQuery(this),
        parentEl = thisEl.parent()

    if (parentEl.hasClass('open')) {
        parentEl.toggleClass('open').next().slideToggle()
    } else {
        parentEl.toggleClass('open').next().slideToggle()
    }

})

var lastScrollTop = 0

jQuery(window).on('scroll', function () {
    let scrollTop = jQuery(window).scrollTop()

    if ( scrollTop > 40 ) {
        jQuery('.first-nav__holder').css( { 'visibility' : 'hidden' } )
        jQuery('.header').addClass( 'header--white' )
    } else {
        jQuery('.first-nav__holder').css( { 'visibility' : 'visible' } )
        jQuery('.header').removeClass( 'header--white' )
    }

    if( lastScrollTop > scrollTop ) {
        jQuery('.first-nav__holder').css( { 'visibility' : 'visible' } )
        jQuery('.first-nav__holder').addClass( 'first-nav__holder--white' )
    }

    if( scrollTop > lastScrollTop || scrollTop <= 40 )
        jQuery('.first-nav__holder').removeClass( 'first-nav__holder--white' )

    lastScrollTop = scrollTop
})

jQuery(document).ready(function(e) {


    // console.log(jQuery('body').hasClass('is-drawer'));

    // if (jQuery('body').hasClass('is-drawer')) {
    //     // jQuery('.header__drawer').find('*').removeAttr('tabindex');
    // }

    if(jQuery('.sticky-header').length > 0){

        

        var lastScrollTop = 0;

        // var headerHeight = jQuery('.header').outerHeight();
        var stickyNav = jQuery('.sticky-header');
        var stickyNavHeight = jQuery('.sticky-header').outerHeight();
        var stickyNavOffset = jQuery('.sticky-header').offset().top;

        var bodyHeight = jQuery('body').height();

        // stickyNav.css( "top", headerHeight );

        jQuery(window).on('scroll', function() {
            

            // var headerHeight = jQuery('.header').outerHeight();
            var stickyNav = jQuery('.sticky-header');
            var stickyNavHeight = jQuery('.sticky-header').outerHeight();

            var scrollTop = jQuery(this).scrollTop() - 2*stickyNavHeight;

            if(scrollTop  < lastScrollTop) {

                ///this is up
               if(lastScrollTop  -  scrollTop + stickyNavHeight > 1){
                   stickyNav.addClass('show');
               }

            } else {
               ///this is down
               if(scrollTop > stickyNavHeight + stickyNavHeight){
                   stickyNav.removeClass('show');
               }
            }

            lastScrollTop = scrollTop;
        })
    }
})

// Update the mega menu click handler

document.addEventListener("DOMContentLoaded", function () {
    const categoryLinks = document.querySelectorAll(".mega-menu__category-link");
    const contentSections = document.querySelectorAll(".mega-menu__content");

    function animateArticles(container, show = true) {
        const articles = container.querySelectorAll('.article-block');
        
        articles.forEach((article) => {
            // Clear any existing transition delays
            // article.style.transitionDelay = '0s';
            article.classList.remove('show');
        });

        if (show) {
            // Add a small delay before starting animations
            
                articles.forEach((article, index) => {
                    const delay = (index+1) * 50;
                    setTimeout(() => {
                        article.classList.add('show');
                    }, delay);
                });
          
        }
    }

    categoryLinks.forEach(link => {
        link.addEventListener("mouseenter", () => {
            const category = link.getAttribute("data-category");

            // Remove active class from all links
            categoryLinks.forEach(l => l.classList.remove('active'));
            
            // Add active class to current link
            link.classList.add('active');

            // Hide all content sections and reset animations
            contentSections.forEach(section => {
                if (section.style.display === "grid") {
                    animateArticles(section, false);
                }
                section.style.display = "none";
            });

            // Show the corresponding content section and animate articles
            const targetSection = document.querySelector(`.mega-menu__content[data-category="${category}"]`);
            targetSection.style.display = "grid";
            animateArticles(targetSection, true);
        });
    });

    jQuery('.header__left__latest, .header__left__explore').on('click', function(e) {
        e.preventDefault();
        
        const $this = jQuery(this);
        const isLatest = $this.hasClass('header__left__latest');
        const targetMenu = isLatest ? '.mega-menu.latest' : '.mega-menu.explore';
        const otherMenu = isLatest ? '.mega-menu.explore' : '.mega-menu.latest';
        const activeClass = isLatest ? 'is-latest-active' : 'is-explore-active';
        const otherClass = isLatest ? 'is-explore-active' : 'is-latest-active';
        
        // Toggle active state of buttons
        jQuery('.header__left__latest, .header__left__explore').removeClass('active');
        if (!jQuery('body').hasClass(activeClass)) {
            $this.addClass('active');
            
            // Initialize first category content when Latest is opened
            if (isLatest) {
                const contentSections = document.querySelectorAll(".mega-menu__content");
                const categoryLinks = document.querySelectorAll(".mega-menu__category-link");
                
                if (contentSections.length > 0) {
                    contentSections[0].style.display = "grid";
                    categoryLinks[0].classList.add('active');
                    setTimeout(() => {
                        animateArticles(contentSections[0], true);
                    }, 10); // Reduced timeout for better responsiveness
                }
            }
        }
        
        // Toggle current menu and remove other menu if open
        jQuery('body').toggleClass(activeClass).removeClass(otherClass);
        
        // Close drawer and search if open
        jQuery('body').removeClass('is-drawer is-search');
        jQuery('.hamburger').removeClass('is-active');
    });
    
    // Update the click outside handler to also remove active states
    jQuery(document).on('click', function(e) {
        const $target = jQuery(e.target);
        const isMenuButton = $target.closest('.header__left__latest, .header__left__explore').length;
        const isMenuContent = $target.closest('.header__mega-menu__holder').length;
        
        if (!isMenuButton && !isMenuContent) {
            jQuery('body').removeClass('is-latest-active is-explore-active');
            jQuery('.header__left__latest, .header__left__explore').removeClass('active');
        }
    });
    
    // Update the escape key handler to also remove active states
    jQuery(document).on('keydown', function(e) {
        if (e.keyCode === 27) {
            if (jQuery('body').hasClass('is-latest-active') || jQuery('body').hasClass('is-explore-active')) {
                jQuery('body').removeClass('is-latest-active is-explore-active');
                jQuery('.header__left__latest, .header__left__explore').removeClass('active');
            }
        }
    });
    
});

// Add this after the search form related code
jQuery('.search__form button[type="submit"]').on('keydown', function(e) {
    if (e.key === 'Tab' && !e.shiftKey && jQuery('body').hasClass('is-search')) {
        e.preventDefault();
        jQuery('.header__search').focus();
    }
});

jQuery('.header').on('focusout', function(e) {
    // Check if the next focused element is still within the header
    setTimeout(() => {
        if (!jQuery(this).has(document.activeElement).length) {
            jQuery('body').removeClass('is-latest-active is-explore-active');
            jQuery('.header__left__latest, .header__left__explore').removeClass('active');
        }
    }, 0);
});